export default {
  id: 190,
  title: 'Target #190 - Power Chip',
  url: 'https://cssbattle.dev/play/190',
  colors: ['#E3516E', '#FADE8B'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[b],p[c]{width:20;background:#e3516e}body,p[b],p[c]{background:#e3516e}p[d],p[e]{top:119;border-width:0 25 40}p[b],p[d],p[e]{border-style:solid;border-color:#e3516e #fade8b}body{margin:0}p{position:fixed}p[a]{top:59;left:60;width:280;height:150;background:#fade8b}p[b]{top:59;left:146.5;height:81;border-width:69 43.5 0}p[c]{top:159;left:115;height:80;box-shadow:150px 0 #e3516e}p[d]{left:100}p[e]{right:100}</style>',
}
